export default "__VITE_ASSET__BQwzKmyo__"